<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <span :style="styleColor">
        {{ showMessage() }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AbatementReminder',
  data () {
    return {
      message: '',
      styleColor: {
        color: 'red'
      }
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    distributorParticipate: {
      type: Boolean,
      default: true
    },
    integratorParticipate: {
      type: Boolean,
      default: true
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  computed: {
  },
  methods: {
    showMessage () {
      let message = '';
      // 现销提示
      if (this.form.salesType === 1) {
        message = `已扣减${this.form.strRebate}%资金点。`;
      }
      return message;
    }
  },
  mounted () {
  }
};
</script>
